<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} đăng ký chương trình
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Chương trình">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.chuong_trinh_id"
                        placeholder="Chọn chương trình"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listChuongTrinh"
                          :key="item.id"
                          :label="item.ten.vi"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Ngày tạo">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.thoi_diem_tao"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="4">
              <el-form-item label="Đối tượng">
                <el-select
                  v-model="mData.tableRules.dataSearch.value.loai_doi_tuong"
                  placeholder="Chọn đối tượng"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listDoiTuong"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
                  </b-col>-->
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0 d-flex">
            <b-col md="3">
              <el-select
                v-model="mData.tableRules.dataSearch.value.loai_doi_tuong"
                placeholder="Chọn đối tượng"
                :disabled="mData.viewMode == 'detail'"
                @change="fn_tableSearch()"
                filterable
              >
                <el-option
                  v-for="item in mData.dataDefault.listDoiTuong"
                  :key="item.code"
                  :label="item.text"
                  :value="item.code"
                ></el-option>
              </el-select>
            </b-col>
            <b-col md="5">
              <el-select
                v-model="mData.dataDefault.huy_hieu_ids"
                placeholder="Chọn huy hiệu"
                :disabled="mData.viewMode == 'detail'"
                multiple
                clearable
                filterable
              >
                <el-option
                  v-for="item in mData.dataDefault.listHuyHieu"
                  :key="item.id"
                  :label="item.ten.vi"
                  :value="item.id"
                ></el-option>
              </el-select>
            </b-col>

            <b-col md="2">
              <el-button @click="fn_capHuyHieu()" type="danger" plain>Cấp huy hiệu</el-button>
            </b-col>
          </b-col>

          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button
                @click="fn_handle('create')"
                type="info"
                v-if="aRole('Officer')"
                plain
              >{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="selectedRow"
            label="Chọn"
            width="60"
            align="center"
            v-if="aRole('Officer')"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.selectedRow"
                @change="fn_changeSelectedRow(scope.row.id,scope.row.selectedRow)"
                v-if="!scope.row.da_duyet"
              ></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column prop="loai_doi_tuong" label="Đối tượng" width="150">
            <template slot-scope="scope">{{scope.row.ten_doi_tuong?scope.row.ten_doi_tuong:''}}</template>
          </el-table-column>
          <el-table-column prop="user_id" label="Người dùng" width="150">
            <!-- <template slot-scope="scope">{{scope.row.account_user?scope.row.account_user:''}}</template> -->
            <template slot-scope="scope">{{scope.row.ten_user?scope.row.ten_user:''}}</template>
          </el-table-column>
          <el-table-column prop="chuong_trinh_id" label="Chương trình" min-width="150">
            <template
              slot-scope="scope"
            >{{scope.row.ten_chuong_trinh?scope.row.ten_chuong_trinh:''}}</template>
          </el-table-column>
          <!-- <el-table-column
            prop="huy_hieu_ids"
            :sortable="mData.tableRules.allowSorting"
            label="Huy hiệu"
            width="150"
          ></el-table-column>-->
          <el-table-column
            prop="thoi_diem_tao"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm tạo"
            :formatter="fn_formatterDatetime"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="thoi_diem_cap_nhat"
            label="Thời điểm cập nhật"
            :formatter="fn_formatterDatetime"
            align="center"
            width="150"
          ></el-table-column>
          <!-- <el-table-column
            prop="nguoi_tao_id"
            :sortable="mData.tableRules.allowSorting"
            label="Người tạo"
             width="150"
          ></el-table-column>-->
          <!-- <el-table-column
            prop="nguoi_cap_id"
            :sortable="mData.tableRules.allowSorting"
            label="Người cấp"
            width="200"
            align="center"
            
          ></el-table-column>-->
          <!-- <el-table-column
            prop="da_duyet"
            :sortable="mData.tableRules.allowSorting"
            label="Duyệt"
            width="80"
            align="center"
            
          >
            <template slot-scope="scope">             
              <el-checkbox
                v-model="scope.row.da_duyet"
                @change="fn_changeTrangThaiDuyet(scope.row.id, scope.row.da_duyet, scope.row.huy_hieu_ids)"
                :disabled="!aRole('Officer')"
              ></el-checkbox>
            </template>
          </el-table-column>-->
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
// import ExtensionService from "../../../service/ExtensionService";
import DangKyChuongTrinhModel from "./DangKyChuongTrinhModel";
import ChuongTrinhApi from "../../../moduleApi/ChuongTrinhApi";
import DangKyChuongTrinhApi from "../../../moduleApi/DangKyChuongTrinhApi";
// import ThanhTichHuyHieuApi from "../../../moduleApi/ThanhTichHuyHieuApi";
import HuyHieuApi from "../../../moduleApi/HuyHieuApi";
import AccountApi from "../../../moduleApi/AccountApi";
// import ProfileApi from "../../../moduleApi/ProfileApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DangKyChuongTrinh", //requied
        // urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DangKyChuongTrinhModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listDoiTuong: DangKyChuongTrinhModel.loaiDoiTuong,
          listChuongTrinh: [],
          listHuyHieu: [],
          listUser: [],
          listUserName1: [],
          listUserName2: [],
          listUserName3: [],
          huy_hieu_ids: [],
          dang_ky_chuong_trinh_ids: []
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await DangKyChuongTrinhApi.list(dataFilter);

      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(DangKyChuongTrinhModel.dataForm),
        res.result
      );
      // let hdvIds = MethodService.findListItemDifferent(resData, "user_id");
      let chuongTrinhIds = MethodService.findListItemDifferent(
        resData,
        "chuong_trinh_id"
      );
      let userIds = MethodService.findListItemDifferent(resData, "user_id");

      // let resHDVApi = await HuongDanVienApi.list({
      //   limit: hdvIds.length,
      //   filters: "id:in:" + hdvIds.join(",")
      // });
      let resCTApi = await ChuongTrinhApi.list({
        limit: chuongTrinhIds.length,
        filters: "id:in:" + chuongTrinhIds.join(",")
      });

      let resUserApi = await AccountApi.list({
        limit: userIds.length,
        filters: "id:in:" + userIds.join(",")
      });

      let resUserName1Api = await HuongDanVienApi.list({
        limit: userIds.length,
        filters: "id:in:" + userIds.join(",")
      });
      let resUserName2Api = await KhachDuLichApi.list({
        limit: userIds.length,
        filters: "id:in:" + userIds.join(",")
      });
      let resUserName3Api = await DiemDenAnToanApi.list({
        limit: userIds.length,
        filters: "id:in:" + userIds.join(",")
      });

      // this.mData.dataDefault.listHDV = resHDVApi.result;
      this.mData.dataDefault.listChuongTrinh = resCTApi.result;
      this.mData.dataDefault.listUser = resUserApi.result;
      this.mData.dataDefault.listUserName1 = resUserName1Api.result;
      this.mData.dataDefault.listUserName2 = resUserName2Api.result;
      this.mData.dataDefault.listUserName3 = resUserName3Api.result;
      // debugger

      $.each(resData, (index, item) => {
        let doiTuong = this.mData.dataDefault.listDoiTuong.find(element => {
          return element.code == item.loai_doi_tuong;
        });
        if (doiTuong) {
          item.ten_doi_tuong = doiTuong.text;
        } else {
          item.ten_doi_tuong = "";
        }
        let chuongTrinh = this.mData.dataDefault.listChuongTrinh.find(
          element => {
            return element.id == item.chuong_trinh_id;
          }
        );
        if (chuongTrinh) {
          item.ten_chuong_trinh = chuongTrinh.ten.vi;
        } else {
          item.ten_chuong_trinh = "";
        }

        let nguoiDung = this.mData.dataDefault.listUser.find(element => {
          return element.id == item.user_id;
        });
        if (nguoiDung) {
          item.account_user = nguoiDung.account;
        } else {
          item.account_user = "";
        }
        if (item.loai_doi_tuong == "tour_guide") {
          let nguoiDungName = this.mData.dataDefault.listUserName1.find(
            element => {
              return element.id == item.user_id;
            }
          );
          if (nguoiDungName) {
            item.ten_user = nguoiDungName.ho_ten.ho_ten;
          } else {
            item.ten_user = "";
          }
        } else {
          if (item.loai_doi_tuong == "customer") {
            let nguoiDungName = this.mData.dataDefault.listUserName2.find(
              element => {
                return element.id == item.user_id;
              }
            );
            if (nguoiDungName) {
              item.ten_user = nguoiDungName.ho_ten.ho_ten;
            } else {
              item.ten_user = "";
            }
          } else if (item.loai_doi_tuong == "place") {
            let nguoiDungName = this.mData.dataDefault.listUserName3.find(
              element => {
                return element.id == item.user_id;
              }
            );
            if (nguoiDungName) {
              item.ten_user = nguoiDungName.ho_ten.ho_ten;
            } else {
              item.ten_user = "";
            }
          }
        }
      });

      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await DangKyChuongTrinhApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await DangKyChuongTrinhApi.disable(id, disable);
      this.fn_initTable();
    },

    fn_changeSelectedRow(id, trangThai) {
      if (trangThai) {
        this.mData.dataDefault.dang_ky_chuong_trinh_ids.push(id);
      } else {
        let index = this.mData.dataDefault.dang_ky_chuong_trinh_ids.indexOf(id);
        if (index !== -1)
          this.mData.dataDefault.dang_ky_chuong_trinh_ids.splice(index, 1);
      }
    },

    async fn_capHuyHieu() {
      if (this.mData.dataDefault.huy_hieu_ids.length <= 0) {
        toastr.error("Bạn chưa chọn huy hiệu");
      } else {
        if (this.mData.dataDefault.dang_ky_chuong_trinh_ids.length <= 0) {
          toastr.error("Bạn chưa chọn chương trình");
        } else {
          try {
            // console.log(this.mData.dataDefault.dang_ky_chuong_trinh_ids, this.mData.dataDefault.huy_hieu_ids);
            debugger;
            let res = await DangKyChuongTrinhApi.duyetThanhTichHuyHieu(
              this.mData.dataDefault.dang_ky_chuong_trinh_ids,
              this.mData.dataDefault.huy_hieu_ids,
              this.mData.tableRules.dataSearch.value.loai_doi_tuong
            );
            if (res.result) {
              console.log(res.result);
            }
            // debugger
          } catch (ex) {}
        }
      }
    },

    async fn_changeTrangThaiDuyet(id, trangThai, huyHieuIds) {
      // let data = {
      //   dang_ky_chuong_trinh_id : id,
      //   da_duyet: trangThai,
      //   huy_hieu_ids: huyHieuIds
      // };
      await DangKyChuongTrinhApi.duyetThanhTichHuyHieu(
        id,
        trangThai,
        huyHieuIds
      );
      // if (trangThai) {
      //   await DangKyChuongTrinhApi.updateChecked(data);
      // }
      // else {
      //   await DangKyChuongTrinhApi.updateUnCheck(data);
      // }
      this.fn_initTable();
    },

    async fn_selectData(id) {
      if (id == "") {
        this.fn_tableSearch();
      } else {
        this.fn_tableSearch();
      }
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {
      let reqHuyHieu = HuyHieuApi.list({
        limit: 1000,
        filters: "co_hieu_luc=true"
      });
      let resHuyHieu = await reqHuyHieu;
      if (resHuyHieu.result) {
        this.mData.dataDefault.listHuyHieu = resHuyHieu.result;
      }
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        console.log(this.mData.tableRules.filters);
        
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );        
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
